export default {
  SET_CHAMPIONSHIP(state, value) {
    state.championship = value;
  },
};
